import React, { useState } from "react";
import { Form, Button, Typography, Radio, message } from "antd";
import { quizQuestions } from "../../assets/constants";

const { Title } = Typography;

const Step19 = ({ form, next, prev }) => {
  const [answers, setAnswers] = useState({});
  const [validated, setValidated] = useState(false);

  const handleSubmit = () => {
    const isCorrect = quizQuestions.every((q, index) => {
      const answer = answers[index];
      return (
        answer && q.options.find((option) => option.value === answer).correct
      );
    });

    if (isCorrect) {
      setValidated(true);
      next();
    } else {
      message.error(
        "Some answers are incorrect. Please correct them to proceed."
      );
    }
  };

  const handleAnswerChange = (index, value) => {
    setAnswers({ ...answers, [index]: value });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ maxWidth: 800, margin: "0 auto" }}
    >
      <Title level={2}>Assessment</Title>
      <p>Please select the best answer.</p>
      {quizQuestions.map((question, index) => (
        <Form.Item
          key={index}
          label={`${index + 1}. ${question.question}`}
          validateStatus={
            answers[index] &&
            !question.options.find((option) => option.value === answers[index])
              .correct
              ? "error"
              : ""
          }
          help={
            answers[index] &&
            !question.options.find((option) => option.value === answers[index])
              .correct
              ? "Your answer is incorrect!"
              : ""
          }
        >
          <Radio.Group
            onChange={(e) => handleAnswerChange(index, e.target.value)}
          >
            {question.options.map((option) => (
              <Radio key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      ))}
      <Form.Item style={{ textAlign: "center" }}>
        <Button onClick={prev} style={{ marginRight: 8 }}>
          Back
        </Button>
        <Button
          type="primary"
          onClick={handleSubmit}
          disabled={
            !validated && Object.keys(answers).length < quizQuestions.length
          }
        >
          Next
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Step19;
